import React from 'react';
import { Waypoint } from '@components/Waypoint';
import { RouteData } from '@appTypes/mapsApiTypes';
import { PointOfInterest } from './RouteCharts';
import { useMapV2Logic } from './useMapV2Logic';

const DEFAULT_POIS: PointOfInterest[] = [];

interface MapV2Props extends google.maps.MapOptions {
  zoom: number;
  center: google.maps.LatLngLiteral;
  style: { [key: string]: string | number };
  children?: React.ReactNode;
  mapId?: string;
  routeData?: RouteData;
  pointsOfInterest?: PointOfInterest[];
  isLoading?: boolean;
  mapOptions?: { animatedPathStroke?: string };
  animate?: boolean;
}

export const MapV2: React.FC<MapV2Props> = ({
  style,
  children,
  routeData,
  pointsOfInterest = DEFAULT_POIS,
  isLoading = false,
  mapOptions,
  animate,
  ...options
}) => {
  const { ref, map, handleWaypointEnter } = useMapV2Logic({
    routeData,
    pointsOfInterest,
    isLoading,
    animatedPathStroke: mapOptions?.animatedPathStroke,
    animate,
    mapOptions: options,
  });

  return (
    <Waypoint onEnter={handleWaypointEnter} topOffset="100px">
      <div style={style} ref={ref} id="map">
        {React.Children.map(children, (child) => {
          if (!React.isValidElement(child) || !map) return null;
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore map is injected into supported map children
          return React.cloneElement(child, { map });
        })}
      </div>
    </Waypoint>
  );
};
